import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { Link } from 'dibs-elements/exports/Link';
import get from 'lodash.get';
import styles from './styles/ShopGrid.scss';

function ShopGridComponent({ landingPage }) {
    const gridItems = get(landingPage, 'grid.items') || [];
    if (!gridItems.length) {
        return null;
    }
    return (
        <div className={styles.wrapper} data-tn="collections-grid">
            {(gridItems || []).map((item, i) => {
                const image = item.imageUrl ? (
                    <img className={styles.image} src={item.imageUrl} />
                ) : null;
                const title = item.title ? <h3 className={styles.title}>{item.title}</h3> : null;
                const tnSuffix = (item.title || '').toLowerCase().replace(/ /g, '-');
                return (
                    <div className={styles.item} key={i} data-tn={`grid-item-${tnSuffix}`}>
                        {!!image &&
                            (item.url ? (
                                <Link href={item.url}>{image}</Link>
                            ) : (
                                <span>{image}</span>
                            ))}
                        {!!title &&
                            (item.url ? (
                                <Link
                                    dataTn={`shop-grid-${tnSuffix}-title`}
                                    href={item.url}
                                    className={styles.link}
                                >
                                    {title}
                                </Link>
                            ) : (
                                title
                            ))}
                        {!!item.description && (
                            <p className={styles.description}>{item.description}</p>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

ShopGridComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopGrid = createFragmentContainer(ShopGridComponent, {
    landingPage: graphql`
        fragment ShopGrid_landingPage on LandingPage {
            grid {
                items {
                    description
                    imageUrl
                    title
                    url
                }
            }
        }
    `,
});
